// extracted by mini-css-extract-plugin
export var audioPlayer = "_t1-0";